import { DOMNode, Element, domToReact } from 'html-react-parser';
import { createElement } from 'react';

const headingTags = ['h1', 'h2', 'h3', 'h4'];
export const headingsReplace = (domNode: DOMNode) => {
  const { name, attribs, children } = domNode as Element;
  if (headingTags.includes(name)) {
    return createElement(
      'p',
      attribs,
      domToReact(children, { replace: headingsReplace }),
    );
  }
};
